<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div class="containerIconLeft" @click="linkBackTo(content)">
              <font-awesome-icon icon="chevron-left" class="IconLeft" />
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardContent :cardContent="content" @nextRoute="nextRoute" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="linkNextTo(content)">
            <font-awesome-icon
              v-if="!loading"
              icon="chevron-right"
              class="IconRight"
            />
            <font-awesome-icon
              v-if="loading"
              icon="spinner"
              class="IconRight"
            />
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardContent from '../../../components/template/Chinese1/CardContent';
import CardPopupImg from './components/CardPopupImg.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardContent, CardPopupImg, LoadingMDL},
  name: 'CTA04',
  data() {
    return {
      content: {},
      lang: this.$store.getters['language/getLanguage'],
      pageCode: '',
      baseURL: 'CTA04-',
      isModalVisible: false,
      popupData: {},
      cardType: 'img',
      isChange: false,
      newPath: '',
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      isCompletedLoad: false,
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
      lessonDone: false,
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      // getUserTemplate: 'template/getUserTemplate',
      // loadingGetter: 'template/loadingGetter',
      getCourseChapterAndProgress: 'template/getCourseChapterAndProgress',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },

    storeLanguage: function (val) {
      this.lang = val;
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'CTA04 save Content watcher');
      if (this.nextPath) {
        this.loading = true;
        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;

        this.$router.push(onNext);
      }
      //when v4SaveContent respond
      //redirect when v4
    },

    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.onLoad();
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},
  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.courseCode = this.$store.state.necessary.learningCourse;
      this.getParams = this.$route.params.id;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `CTA04-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkLastLesson() {
      //compare codeItem
      const currentCode = this.v3Data.codeItem;
      const lastCode = this.v3Data.lastContent;
      //lesson done true if current === last
      if (currentCode === lastCode) {
        this.lessonDone = true;
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(path) {
      if (path.type == undefined) {
        const splitPath = path.path.split('-');
        const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
        this.$router.push(nextPath);
      }
    },
    returnData(str) {
      this.isChange = true;
      this.newPath = str[0] + '-' + str[1];
    },
    linkNextTo(path) {
      this.loading = true;
      this.nextAction = path.navigate.next.action;

      //update stack on next
      this.commitPayloadData(this.nextAction);
    },
    linkBackTo(path) {
      const previousAction = path.navigate.previous.action;

      const previous = previousAction.split('-');
      var pathCheck = previous[0];
      const previousPath = `/v4/${previous[0]}/${previous[1]}`;

      if (pathCheck === 'CTA04') {
        this.loading = true;
        //CTA04

        this.$router.push(previousPath);
      } else {
        this.$router.push(previousPath);
      }
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];

      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          console.log('current Code = lastCode save content and clear stack');

          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
};
</script>
<style></style>
